import lazyLoad from 'core/util/lazyLoad';
import TextPanel from 'app/views/boards/panels/TextPanel';
import UdePanel from 'app/views/boards/panels/ude/UdePanel';
import UdePanelForm from 'app/views/boards/panels/ude/UdePanelForm';
import UdePanelTools from 'app/views/boards/panels/ude/UdePanelTools';
import UdeChartSettingsForm from 'app/views/boards/panels/ude/UdeChartSettingsForm';

import SectionPanelTitleTools from 'app/views/boards/panels/section/SectionPanelTitleTools';
import WidgetPanel from 'app/views/boards/panels/widget/WidgetPanel';
import WidgetPanelForm from 'app/views/boards/panels/widget/WidgetPanelForm';
import WidgetSettingsForm from 'app/views/boards/panels/widget/WidgetSettingsForm';
import PanelOptions from 'app/views/boards/panels/PanelOptions';
import { TbDashboard, TbDatabasePlus, TbSection, TbTextCaption } from 'react-icons/tb';
import udeFields from './panels/udeFields';

const SectionPanel = lazyLoad(() => import('app/views/boards/panels/section/SectionPanel'), { fallback: null });
const SectionPanelOptions = lazyLoad(() => import('app/views/boards/panels/section/SectionPanelOptions'), {
  fallback: null
});

export const boardPanelTypes = {
  ude: {
    title: 'New Query',
    description:
      'Add a query panel to your board. Queries can be Traffic, NMS, Synthetics, Cost, and many more areas from the Kentik platform',
    component: UdePanel,
    options: PanelOptions,
    form: UdePanelForm,
    settings: UdeChartSettingsForm,
    panelTools: UdePanelTools,
    showApplyButton: true,
    icon: TbDatabasePlus,
    fields: udeFields,
    sidebarWidth: '360px',
    shouldShowSettings(config) {
      const metrics = config.data?.metrics || [];
      const dimensions = config.data?.dimensions || [];
      return metrics.length > 0 || dimensions.length > 0;
    },
    layoutDefaults: {
      lg: {
        w: 6,
        h: 8,
        minH: 4,
        minW: 3
      },
      sm: {
        h: 8,
        minH: 4
      }
    }
  },

  widget: {
    title: 'Widget',
    description: 'An observation deck widget',
    options: PanelOptions,
    icon: TbDashboard,
    fields: {
      'config.widgetName': {
        label: 'Widget'
      }
    },
    form: WidgetPanelForm,
    component: WidgetPanel,
    settings: WidgetSettingsForm
  },

  section: {
    title: 'Section',
    description: 'A container for other panels that can be collapsed and expanded',
    component: SectionPanel,
    options: SectionPanelOptions,
    titleTools: SectionPanelTitleTools,
    icon: TbSection,
    layoutDefaults: {
      lg: {
        w: 12,
        h: 4,
        minW: 12,
        minH: 0.5
      },
      sm: {
        h: 4,
        minH: 0.5
      }
    },
    autoSize: true
  },

  text: {
    title: 'Text',
    description: 'Supports Markdown and HTML content',

    fields: {
      'config.content': {
        label: 'Content',
        helpText: 'Supports Markdown content',
        defaultValue: ''
      },
      'config.backgroundColor': {
        label: 'Background Color',
        defaultValue: 'transparent'
      },
      'config.fontSize': {
        label: 'Font Size',
        defaultValue: 'MD'
      },
      'config.textAlign': {
        label: 'Text Align',
        defaultValue: 'left'
      },
      'config.verticalAlign': {
        label: 'Vertical Align',
        defaultValue: 'top'
      }
    },
    options: PanelOptions,
    component: TextPanel,
    icon: TbTextCaption,
    layoutDefaults: {
      lg: {
        w: 6,
        h: 4,
        minH: 1,
        minW: 1
      },
      sm: {
        h: 4
      }
    }
  }
};

export function getBoardPanelComponent(panel) {
  return boardPanelTypes[panel.get('type')] || {};
}

export default boardPanelTypes;
